<template lang="pug">
    .profile.card.is-unselectable(:class="{ 'is-active': active }")
        .card-header
            .card-header-title
              template(v-if="id")
                span(v-if="!editable") {{ name }}
                input.input.is-small(:value="name" @input="$emit('name', { id, name: $event.target.value })" v-else)
              input.input.is-small(v-model="defaultName" v-else)
            .dropdown(:class="{ 'is-active': showMenu }")
                .dropdown-trigger
                    a.card-header-icon(@click="toggleMenu")
                        span.icon
                            i.fas.fa-ellipsis-h
                .dropdown-menu
                    .dropdown-content
                        template(v-if="id")
                            a.dropdown-item(@click="edit" v-if="!editable") Edit
                            a.dropdown-item(@click="save" v-if="editable") Save
                            a.dropdown-item(@click="remove") Delete
                        template(v-else)
                            a.dropdown-item(@click="create") Create
        .card-content
            .level
                .level-left
                    button.button.level-item(:class="{ 'is-success': liveValue }" @click="update('live', !liveValue)")
                        span.icon
                            i.fas.fa-bolt
                        span Live
                .level-right
                    button.button.level-item(:class="{ 'is-success': dadbeeValue }" @click="update('dadbee', !dadbeeValue)")
                        span.icon
                            i.fab.fa-telegram-plane
                        span Dadbee
</template>

<script>
import EditInput from "@/components/EditInput";

export default {
  name: "Profile",
  data: () => ({
    showMenu: false,
    defaultName: "ProfileName",
    defaultLive: false,
    defaultDadbee: false,
    editable: false
  }),
  components: {
    EditInput
  },
  props: {
    id: String,
    live: Boolean,
    dadbee: Boolean,
    name: String,
    settings: Array,
    active: Boolean
  },
  computed: {
    nameValue() {
      return this.id ? this.name : this.defaultName;
    },
    liveValue() {
      return this.id ? this.live : this.defaultLive;
    },
    dadbeeValue() {
      return this.id ? this.dadbee : this.defaultDadbee;
    }
  },
  methods: {
    create() {
      if (!this.nameValue || !this.nameValue.length) {
        alert("Please, enter profile name.");
        return;
      }
      if (confirm(`Do you want to create new profile "${this.nameValue}"?`)) {
        this.toggleMenu();
        this.$emit("create", {
          name: this.nameValue,
          live: this.liveValue,
          dadbee: this.dadbeeValue
        });
        this.defaultName = "ProfileName";
        this.defaultLive = false;
        this.defaultDadbee = false;
      }
    },
    edit() {
      this.editable = true;
      this.toggleMenu();
      this.$emit("edit", this.id);
    },
    save() {
      this.toggleMenu();
      this.editable = false;
      this.$emit("update", { id: this.id });
    },
    remove() {
      if (confirm(`Do you want to delete profile "${this.nameValue}"?`)) {
        this.$emit("remove", this.id);
        this.toggleMenu();
      }
    },
    update(key, value) {
      if (!this.id) {
        const defaultKey = `default${key.charAt(0).toUpperCase() +
          key.slice(1)}`;
        this[defaultKey] = value;
      } else {
        this.$emit("update", { id: this.id, data: { [key]: value } });
      }
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  }
};
</script>

<style lang="scss" scoped>
.profile {
  border-radius: 5px;
  background-color: $cardFontColor;
  color: $white;

  &.is-active {
    box-shadow: 0 0 3px 2px $brandColor;
  }

  .card-header {
    box-shadow: none;
    .card-header-title {
      color: $white;
    }
    .card-header-icon {
      color: $white;
    }
    .dropdown {
      .dropdown-menu {
        right: 0;
        left: auto;
      }
    }
  }
}
</style>
